module.exports = __webpack_public_path__ + "imgs/gosPartnersLogo3.88343fa3.webp";